import { Helmet } from 'react-helmet-async';
import { useSiteData } from '@/hooks/useSiteData';
import { useHeroData } from '@/hooks/useHeroData';
import { useFeaturedPostsData } from '@/hooks/useFeaturedPostsData';
import { useServiceHighlightsData } from '@/hooks/useServiceHighlightsData';
import { useTestimonialsData } from '@/hooks/useTestimonialsData';
import { useSocialMediaData } from '@/hooks/useSocialMediaData';
import { useFooterData } from '@/hooks/useFooterData';
import { Header } from '@/components/layout/Header';
import { Footer } from '@/components/layout/Footer';
import { Hero } from '@/components/sections/Hero';
import { FeaturedPosts } from '@/components/sections/FeaturedPosts';
import { ServiceHighlights } from '@/components/sections/ServiceHighlights';
import { ClientTestimonials } from '@/components/sections/ClientTestimonials';
import { SocialMedia } from '@/components/sections/SocialMedia';

export function Index() {
  const { siteData } = useSiteData();
  const { heroData } = useHeroData();
  const { featuredPostsData } = useFeaturedPostsData();
  const { serviceHighlightsData } = useServiceHighlightsData();
  const { testimonialsData } = useTestimonialsData();
  const { socialMediaData } = useSocialMediaData();
  const { footerData } = useFooterData();

  return (
    <>
      <Helmet>
        <title>{siteData.title}</title>
        <meta name="description" content={siteData.description} />
        <meta name="keywords" content={siteData.keywords} />
      </Helmet>
      
      <div className="min-h-screen">
        <Header />
        <Hero data={heroData} />
        <FeaturedPosts data={featuredPostsData} />
        <ServiceHighlights data={serviceHighlightsData} />
        <ClientTestimonials data={testimonialsData} />
        <SocialMedia data={socialMediaData} />
        <Footer data={footerData} />
      </div>
    </>
  );
}